import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHapticFeedback: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="haptic-feedback, vibration"><path d="M18.25 1.75H5.75V22.25H18.25V1.75Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="6.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="2.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconHapticFeedback;
